var map = {
	"./2020.png": 32,
	"./404-adna.png": 39,
	"./CAFFEINE.png": 78,
	"./behavior.png": 79,
	"./behavior_exercise.png": 80,
	"./behavior_sleep.png": 81,
	"./behavior_snacking.png": 82,
	"./body.png": 83,
	"./body_adiposity.png": 84,
	"./body_foodcravings.png": 85,
	"./body_imc.png": 86,
	"./body_insulin.png": 87,
	"./body_ldl.png": 88,
	"./body_steatosis.png": 89,
	"./body_triglycerides.png": 90,
	"./body_weightloss.png": 91,
	"./body_weightregain.png": 92,
	"./body_whr.png": 93,
	"./cerba.png": 94,
	"./dnyou.png": 95,
	"./flag_DE.png": 40,
	"./flag_EN.png": 41,
	"./flag_ES-ES.png": 42,
	"./flag_IT-IT.png": 43,
	"./flag_PT-BR.png": 44,
	"./flag_PT-PT.png": 45,
	"./food.png": 96,
	"./food_caffeine.png": 97,
	"./food_carbs.png": 98,
	"./food_complexcarbs.png": 99,
	"./food_fat.png": 100,
	"./food_fiber.png": 101,
	"./food_gluten.png": 102,
	"./food_lactose.png": 103,
	"./food_mufa.png": 104,
	"./food_protein.png": 105,
	"./food_pufa.png": 106,
	"./food_restriction.png": 107,
	"./food_salt.png": 108,
	"./food_vitamins.png": 109,
	"./heartcolor.png": 33,
	"./hg-heart-logo.png": 110,
	"./hg.png": 46,
	"./iproprium.png": 111,
	"./pathotrier.png": 112,
	"./unilabs.png": 113
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21;